import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgbcl-shield-icon',
  template: '<svg id="shield-icon" viewBox="0 -960 960 960" [attr.fill]="color" [attr.width]="size" [attr.height]="size"><path d="M480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Z"/></svg>'
})
export class ShieldIconComponent {
    @Input() color = '#707070';
    @Input() size = 30;
}
